module.exports = __webpack_public_path__ + "img/img18.6f47e2bf.svg";